import { FC, useCallback, useEffect, useState } from "react";
import {
    Wrapper,
    Container,
    Popup,
    BgImage,
    CloseButton,
    Content,
    ButtonContainer,
    SubmitButton,
} from "./styled"
import { CloseOutlined } from "@ant-design/icons";

interface StoryScreenProps {
    action?: () => void;
    url?: string;
    image?: string;
}

export const StoryScreen: FC<StoryScreenProps> = ({ action, image }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(true);

    const closeWindow = useCallback(() => {
        setIsPopupOpen(false);
    }, []);

    const onClick = useCallback(() => {
        if (action) {
            action();
        }
        closeWindow();
    }, [action, closeWindow]);

    if (!isPopupOpen || !image) {
        return null;
    }

    return (
        <Wrapper onClick={(e) => closeWindow()}>
            <Container>
                <Popup onClick={(e) => e.stopPropagation()}>
                    <CloseButton onClick={closeWindow}>
                        <CloseOutlined />
                    </CloseButton>
                    <BgImage src={image} />
                    <Content>
                        <ButtonContainer>
                            <SubmitButton onClick={onClick} size="large">
                                <span className="mt-2 font-bold">
                                    Хочу билет
                                </span>
                            </SubmitButton>
                        </ButtonContainer>
                    </Content>
                </Popup>
            </Container>
        </Wrapper>
    )
}